var React = require('react');

function LinkedinIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#000","fillRule":"evenodd","d":"M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25zm0-3c12.15 0 22-9.85 22-22S37.15 3 25 3 3 12.85 3 25s9.85 22 22 22zM14 20.118v14.54h4.71v-14.54H14zM16.665 13C15.053 13 14 14.086 14 15.512c0 1.396 1.022 2.513 2.604 2.513h.03c1.642 0 2.665-1.117 2.665-2.513-.03-1.426-1.023-2.512-2.634-2.512zm13.912 7.118c-2.5 0-3.62 1.411-4.246 2.401v-2.06h-4.71c.062 1.365 0 14.541 0 14.541h4.71v-8.12c0-.435.031-.868.156-1.18.34-.868 1.115-1.767 2.416-1.767 1.705 0 2.387 1.334 2.387 3.288V35H36v-8.337c0-4.466-2.324-6.545-5.423-6.545zm0 0"}));
}

LinkedinIcon.defaultProps = {"viewBox":"0 0 50 50"};

module.exports = LinkedinIcon;

LinkedinIcon.default = LinkedinIcon;
